import axios from 'axios';
import * as Constants from '../common/constants';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { EmailDataModel } from '../models/emailDataModel';

class MailService {

  // constructor() {
  //   axios.defaults.baseURL = `${Constants.apiUrl}`;
  // }

  sendEmail(emailData: EmailDataModel) {
    return axios({
      url: `${Constants.apiUrl}/mail/sendMail/`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(emailData)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default MailService;